import { Image as ImageIcon, Send } from 'lucide-react';

export interface ComposerProps {
  text?: string;
  active?: boolean;
}

export function Composer({ text = 'Message', active = false }: ComposerProps) {
  return (
    <div className={`mk-composer${active ? ' is-active' : ''}`}>
      <div className='mk-composer__input'>
        <ImageIcon className='mk-composer__gallery' size={18} strokeWidth={2} />
        <span className='mk-composer__text'>{text}</span>
      </div>
      <span className='mk-composer__send'>
        <Send size={18} strokeWidth={2.2} />
      </span>
    </div>
  );
}
